import '../../../tc-vue-mixins/src/form-mixins.scss.js';
import '../../../tc-vue-mixins/src/edit-mode.js';
import formField from '../../../tc-vue-mixins/src/form-field.js';
import '../../../tc-vue-mixins/src/input-values.js';
import validatable from '../../../tc-vue-mixins/src/validatable.js';
import '../../../tc-vue-mixins/src/overlays.js';
import ArrowDown from '../../../foundations/tc-icons/dist/arrow-down.vue.js';
import TcLabel from '../../tc-label/src/TcLabel.vue.js';
import TcValidationError from '../../tc-form-states/src/TcValidationError.vue.js';
import '../../tc-form-states/src/TcValidationPending.vue.js';
import closable from '../../../tc-vue-directives/src/closable.js';

//

var iconClasses = ['tc-dropdown__icon', 'tc-dropdown__icon--rotate-180'];
var listClasses = ['tc-dropdown__list', 'tc-dropdown__list--hidden'];
var defaultLabel = 'Add label for accessibility';

var script = {
  name: 'TcDropdown',
  directives: {
    closable: closable
  },
  components: {
    TcLabel: TcLabel,
    TcValidationError: TcValidationError,
    ArrowDown: ArrowDown
  },
  mixins: [formField, validatable],
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      required: true,
      default: defaultLabel
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    options: {
      required: true,
      type: Array
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    defaultChoice: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      showMenu: false,
      activeItem: {
        label: '',
        value: null
      }
    }
  },
  computed: {
    eventListeners: function eventListeners() {
      var vm = this;
      return Object.assign({}, vm.$listeners,
        {change: function change(event) {
          vm.$emit('change', event.target.value);
        }})
    },
    activeOptionIndex: function activeOptionIndex() {
      var this$1 = this;

      return this.options.findIndex(function (el) { return el === this$1.activeItem; })
    },
    setLabel: function setLabel() {
      var className = 'tc-dropdown-item__label--warning';

      if (this.label !== defaultLabel && this.hideLabel)
        { className = 'tc-dropdown-item__label--hidden'; }
      else if (this.label !== defaultLabel && !this.hideLabel)
        { className = 'tc-dropdown-item__label'; }

      return className
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      if (!this.showMenu) {
        this.showMenu = true;
        this.$nextTick().then(this.$refs.options.focus());
      } else {
        this.showMenu = false;
      }
    },
    selectItem: function selectItem() {
      this.$emit('change', this.activeItem.value);
      this.toggleMenu();
    },
    optionIndex: function optionIndex(direction) {
      var index;
      if (direction === 'up') {
        var prev = this.activeOptionIndex - 1;
        index = prev >= 0 ? prev : this.options.length - 1;
      }
      if (direction === 'down') {
        var next = this.activeOptionIndex + 1;
        index = next <= this.options.length - 1 ? next : 0;
      }
      return index
    },
    moveToOption: function moveToOption(direction) {
      var index = this.optionIndex(direction);
      var item = this.options[index];
      if (!item.disabled) { return (this.activeItem = this.options[index]) }

      if (item.disabled) {
        if (direction === 'up')
          { return (this.activeItem = this.options[index - 1]) }
        if (direction === 'down')
          { return (this.activeItem = this.options[index + 1]) }
      }
    },
    disabledOption: function disabledOption(option) {
      var classes = 'tc-dropdown__item';

      if (option.disabled) { return (classes += '--disabled') }
      if (this.activeItem.value === option.value)
        { return (classes += ' is-active') }
    },
    availableOptions: function availableOptions(option) {
      if (!option.disabled) { this.activeItem = option; }
    },
    toggleClassNames: function toggleClassNames(el) {
      if (el === 'icon') { return !this.showMenu ? iconClasses[0] : iconClasses }
      if (el === 'list') { return this.showMenu ? listClasses[0] : listClasses }
    }
  },
  mounted: function mounted() {
    this.activeItem = this.options[this.defaultChoice];
  }
};

export default script;
